import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=55b6da6f&scoped=true"
import script from "./ProductListItem.vue?vue&type=script&lang=js"
export * from "./ProductListItem.vue?vue&type=script&lang=js"
import style0 from "./ProductListItem.vue?vue&type=style&index=0&id=55b6da6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b6da6f",
  null
  
)

export default component.exports